export default "__VITE_ASSET__CyTthN7k__"